import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { read, utils, writeFile } from 'xlsx';
import PublishIcon from '@material-ui/icons/Publish';
import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  FormControlLabel,
  TextField,
  Backdrop,
  CircularProgress,
  MenuItem,
  Stack,
  Checkbox
} from '@material-ui/core';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { useConstantsContext } from '../../context/constants_context';

// const useStyles = makeStyles({
//   table: {
//     minWidth: 650
//   }
// });

const NewChangeFile = () => {
  const m = moment();
  const { subsAmount, assureAmount } = useSettingContext();
  const { payCycles } = useConstantsContext();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState(0);
  const [cycleRefId, setCycleRefId] = useState(0);
  const [subAmount, setSubsAmount] = useState(subsAmount);
  const [addRevenue, setAddRevenue] = useState(false);
  const [monthDate, setMonthDate] = useState();
  const [insuranceAmount, setAssureAmount] = useState(assureAmount);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [uploadedFile, setUploadedFile] = useState([]);
  const navigate = useNavigate();

  const currencies = [
    {
      value: 3,
      label: 'USD'
    },
    {
      value: 1,
      label: 'Zim Dollar'
    }
  ];

  const options = {
    raw: false,
    dateNF: 'yyyy-mm-dd' // Specify the date format string here
  };

  const handleImport = ($event) => {
    setLoading(true);
    const { files } = $event.target;
    if (files.length) {
      const file = files[0];
      if (file.name.substring(5, 10) === '43580') {
        setCurrency(1);
      } else {
        setCurrency(3);
      }
      setMonthDate(
        new Date(
          file.name.substring(12, 16),
          (Number(file.name.substring(10, 12)) - 1).toString(),
          '01'
        )
      );
      console.log(
        'ipapa ipapa: ',
        new Date(
          file.name.substring(12, 16),
          (Number(file.name.substring(10, 12)) - 1).toString(),
          '01'
        )
      );
      setUploadedFile(file);
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result, {
          type: 'binary',
          cellDates: true,
          cellNF: false,
          cellText: false
        });
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], options);
          // setRecords(rows);
          // console.log('info:', rows);
          let newOptions = [];
          newOptions = rows.map((e) => ({
            AreaCode: e['Area code'],
            Department: e.Department,
            District: e.Desc,
            EmployeeNumber: e['Emp.No.'],
            Gender: e.Gender,
            Initials: e.Initials,
            IdNumber: e['Nat. Reg. No.'],
            OnOff: e['On/Off'],
            Stat: e['Stat.'],
            StationDescription: e['Station Description'],
            Status: e.Status,
            Subsection: e.Subsection,
            Surname: e.Surname
          }));
          console.log('newOptions:', newOptions);
          setRecords(newOptions);
          setLoading(false);
        } else {
          setLoading(false);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const uploadSsbChangeFiles = () => {
    if (currency === 0 || cycleRefId === 0) {
      notifyPopup(`The Currency or the Stroke is not selected!`, 'error');
      return;
    }

    if (uploadedFile.length === 0) {
      notifyPopup(`Please select file to upload!`, 'error');
      return;
    }
    setLoading(true);
    const jsonClient = [];
    const jsonData = {
      employerRefId: 1,
      ssbFileName: uploadedFile.name,
      upLoadDate: new Date(),
      upLoadedBy: sessionStorage.getItem('userRefId'),
      processState: 0,
      subsAmount: 0,
      insuranceAmount: 0,
      exchangeRate,
      fileType: 1,
      cycleRefId,
      addRevenue,
      currency
    };
    jsonClient.push(jsonData);
    fetch(`${baseUrl}/api/ssb/saveSsbChangeFile`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          uploadSsbChangeDetails(result.refId);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving SSB Changes File!: ${error}`, 'error');
        }
      );
  };

  const uploadSsbChangeDetails = async (result) => {
    setLoading(true);
    const details = records.map((obj) => ({
      ...obj,
      SsbFileRefId: result,
      FileName: uploadedFile.name,
      MonthDate: monthDate,
      Processed: false
    }));

    const jsonData = {
      details
    };

    const jsonClient = [];
    jsonClient.push(jsonData.details);
    fetch(`${baseUrl}/api/ssb/SaveSsbChangeDetail`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned change file', res);
          setLoading(false);
          navigate('/ssb/changefile');
          notifyPopup(`Ssb Change Records Uploaded Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Uploading Change SsbFile!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Card>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Typography variant="h4">Extract SSB Changes File</Typography>
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ mb: 2 }}>
          <Box component="span" sx={{ p: 1, border: '1px solid grey', borderRadius: 1 }}>
            <input
              type="file"
              name="file"
              className="custom-file-input"
              id="inputGroupFile"
              required
              onChange={handleImport}
              // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3}>
              <TextField
                id="cycleRefId"
                style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={cycleRefId}
                onChange={(e) => setCycleRefId(e.target.value)}
              >
                <MenuItem key="" value="0">
                  Select Stroke
                </MenuItem>
                {payCycles.map((item) => (
                  <MenuItem key={item.payCycleId} value={item.payCycleId}>
                    {moment(item.payDate).isValid()
                      ? moment(item.payDate).format('YYYY-MM-DD')
                      : ''}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="standard-select-currency"
                style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
              >
                <MenuItem key="" value="0">
                  Select Currency
                </MenuItem>
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <Button
            type="button"
            variant="outlined"
            sx={{ minWidth: '180px', p: 1, px: 2, color: 'white', backgroundColor: '#000000' }}
            startIcon={<PublishIcon />}
            onClick={() => uploadSsbChangeFiles()}
          >
            Save File
          </Button>
        </Stack>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">MemberName</TableCell>
                <TableCell align="right">ECNumber</TableCell>
                <TableCell align="right">On/Off</TableCell>
                <TableCell align="left">Status Reason</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {records.map((row) => (
                <TableRow>
                  <TableCell align="left">
                    {row.Surname} {row.Initials}
                  </TableCell>
                  <TableCell align="right">{row.EmployeeNumber}</TableCell>
                  <TableCell align="right">{row.OnOff}</TableCell>
                  <TableCell align="left">{row.Status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </CardContent>
    </Card>
  );
};

export default NewChangeFile;
